var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomewhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.439 10.7159C22.4385 10.7154 22.438 10.7149 22.4375 10.7143L13.2498 1.52705C12.8582 1.13526 12.3376 0.919434 11.7837 0.919434C11.2299 0.919434 10.7092 1.13509 10.3174 1.52688L1.13461 10.7095C1.13152 10.7126 1.12843 10.7159 1.12533 10.719C0.321136 11.5278 0.32251 12.8401 1.12929 13.6469C1.49788 14.0157 1.98469 14.2293 2.50519 14.2516C2.52633 14.2537 2.54763 14.2547 2.56911 14.2547H2.9353V21.016C2.9353 22.3539 4.02389 23.4425 5.36216 23.4425H8.95665C9.32095 23.4425 9.61651 23.1471 9.61651 22.7827V17.4818C9.61651 16.8713 10.1131 16.3747 10.7237 16.3747H12.8438C13.4543 16.3747 13.9509 16.8713 13.9509 17.4818V22.7827C13.9509 23.1471 14.2463 23.4425 14.6108 23.4425H18.2053C19.5436 23.4425 20.6321 22.3539 20.6321 21.016V14.2547H20.9717C21.5254 14.2547 22.046 14.0391 22.438 13.6473C23.2456 12.8391 23.246 11.5246 22.439 10.7159Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomewhite);
export default __webpack_public_path__ + "static/media/homewhite.ae8d69380901b9b4fd282aedee3acd4e.svg";
export { ForwardRef as ReactComponent };